module.exports = __webpack_public_path__ + "img/ani_test_atlas_P_.1d943aac.png";